module.exports = __webpack_public_path__ + "static/img/error_load_fail.6cadfcd5.png";